import { initSmoothScrolling } from './scroll/leniscroll';
import {
  initBlurSplitText,
  initParallax,
  initFadeIn,
  initFadeInOnScroll,
} from './animations';

initSmoothScrolling();

document.addEventListener('DOMContentLoaded', () => {
  initBlurSplitText();
  initParallax();
  initFadeIn();
  initFadeInOnScroll();
});
